<template>
	<Col class="width-100 height-100 page-wrapper">
		<Col class="width-100 height-100 flex-align-center overflow-y-auto">
			<Col class="content-container height-100">
				<Row class="flex-align-center mt-3">
					<router-link :to="{ name: GETTING_STARTED_ROUTE_NAME }" class="mr-2">
						<AnemicButton class="back-button" width="25" height="25" fab x-small>
							<AppIcon name="back" />
						</AnemicButton>
					</router-link>
					<h1 class="reg">Welcome to Ply 👋</h1>
				</Row>
				<Row class="flex-justify-space-between my-3">
					<Row class="onboarding-title">Get started with {{ readableFeatureType }}s</Row>
					<Row class="flex-align-center">
						<AnemicButton v-if="canCreateNew" @click="showWizard" class="new-button ml-6">New {{ readableFeatureType }}</AnemicButton>
					</Row>
				</Row>
				<Col class="embedded-iframe-container width-100 height-100 flex-centerize">
					<AppLoader v-if="isLoadingIframe" />
					<iframe
						width="100%"
						height="100%"
						allowfullscreen
						v-show="!isLoadingIframe"
						:src="settings.iframeUrl"
						@load="isLoadingIframe = false"
						class="embedded-iframe-container"
					/>
				</Col>
			</Col>
		</Col>
	</Col>
</template>

<script>
import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';

import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { GETTING_STARTED_ROUTE_NAME } from '@/router/router.const';
import { hasAccountPermission } from '@/store/modules/account/getters';
import { useGettingStartedSettings } from '@/store/modules/featureFlags/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { capitalizeWord } from '@/utils/language-service';
import { SLACK_PLACEMENT_ID } from '@/utils/workflow-tool-service.const';
export default {
	name: 'GettingStartedLandingPage',
	props: {
		featureType: { type: String, required: true },
	},
	components: {},
	computed: {
		...mapGettersShorthand({ hasAccountPermission, useGettingStartedSettings }),
		canCreateNew() {
			return this.hasAccountPermission(AccountPermissions.CreateWorkflows);
		},
		readableFeatureType() {
			return capitalizeWord(this.settings.noun);
		},
		settings() {
			return this.useGettingStartedSettings.find((setting) => setting.id === this.featureType) || {};
		},
		isSlackMode() {
			return this.featureType === SLACK_PLACEMENT_ID;
		},
	},
	methods: {
		showWizard() {
			const toolPlacement = this.isSlackMode ? SLACK_PLACEMENT_ID : null;
			AppDialogManagerService.openCreationWizardDialog({
				initialState: { featureTypeId: this.featureType, toolPlacement },
			});
		},
	},
	data() {
		return {
			isLoadingIframe: true,
			GETTING_STARTED_ROUTE_NAME,
		};
	},
};
</script>

<style scoped lang="scss">
.page-wrapper {
	background: #f9fafc;
}
.new-button {
	width: 145px !important;
	padding: 0px !important;
	height: 45px !important;
	border-radius: 8px !important;
	background-color: #6762f0 !important;

	color: var(--bg-color);
	font-size: 14px !important;
	font-weight: normal !important;
}
.onboarding-title {
	font-size: 30px;
	font-weight: bold;
	letter-spacing: 0px;
	color: var(--primary-font-color);
}
.content-container {
	opacity: 1;
	height: 100%;
	margin: 70px 0 70px 0;
	max-width: 1120px;
	width: calc(100% - 40px);
}
.embedded-iframe-container {
	border-radius: 15px;
	box-shadow: 0px 2px 10px 2px #00000012;
}
.back-button {
	background: #f9fafc !important;
	border: 1px solid #e0e0e0 !important;
}
</style>
